/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { IErrorResponse, IFeeWaiverCode } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class FeeWaiverCodeApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Fee Waiver Code API
   * @name GetFeeWaiverCode
   * @summary Get a fee waiver code
   * @request GET:/api/fee-waiver-codes/{feeWaiverCode}
   * @response `200` `IFeeWaiverCode`
   * @response `401` `IErrorResponse` Not signed in.
   */
  getFeeWaiverCode = (feeWaiverCode: string, params: RequestParams = {}) =>
    this.request<IFeeWaiverCode, IErrorResponse>({
      path: `/api/fee-waiver-codes/${feeWaiverCode}`,
      method: "GET",
      format: "json",
      ...params,
    });
}
